export default {
  backLinkProjects: 'Tutti i progetti',
  readProjects: 'Esplora il progetto',
  otherTitle: 'Altri progetti',
}
